import { defineComponent, resolveDirective, createElementBlock, openBlock, Fragment, renderList, withDirectives, normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "flex justify-start overflow-hidden rounded bg-p-blue-20",
  role: "progressbar"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PProgressBar"
  },
  __name: "p-progress-bar",
  props: {
    total: {},
    items: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
          return withDirectives((openBlock(), createElementBlock("div", {
            key: `progress-value-${item.color}`,
            class: "h-full",
            style: normalizeStyle({ width: `${item.value / _ctx.total * 100}%`, background: item.color })
          }, null, 4)), [
            [
              _directive_tooltip,
              item.label,
              void 0,
              { top: true }
            ]
          ]);
        }), 128))
      ]);
    };
  }
});
export {
  _sfc_main as _
};
